/* script */


























































import Vue, { PropType } from 'vue'
import { showSuccess, showError } from '../lib/toastify-js'
import { Turbo } from '@hotwired/turbo-rails'
import {
  sellersDashboardPath,
  sellersBusinessPath,
  newSellersBusinessPath,
} from '../lib/rails-routes'
import { Business } from '../types/index'
import BulkDealSubmittedMessage from './BulkDealSubmittedMessage.vue'

const __vue_script__ = Vue.extend({
  components: {
    BulkDealSubmittedMessage,
  },
  props: {
    business: {
      type: Object as PropType<Business>,
      required: true,
    },
    errorDeals: {
      type: Array,
      default: (): any[] => [],
    },
    initialMessageBody: {
      type: String,
      required: true,
    },
    toaIds: {
      type: Array,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    nextBusiness: {
      type: Object as PropType<Business>,
      required: false,
      default: null,
    },
    selectedToasCount: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      messageBody: this.initialMessageBody,
      submitting: false,
      submitted: false,
      messageFile: null,
      modalShown: false,
      ownerCompanyAddress: this.business.businessOwnerCompanyAddress,
      ownerCompanyName: this.business.businessOwnerCompanyName,
      ownerCompanyRepresentativeName: this.business.businessOwnerCompanyRepresentativeName,
      transferSubject: this.business.transferSubject,
    }
  },
  computed: {
    errorDealsExists(): boolean {
      return this.errorDeals.length > 0
    },
    hasNextBusiness(): boolean {
      return this.nextBusiness !== null
    },
    nextBusinessPath(): string {
      return `${sellersBusinessPath({
        id: this.nextBusiness.id,
        new_filter: 'true',
      })}#business-toas`
    },
    newBusinessPath(): string {
      return newSellersBusinessPath()
    },
    selectedToasCountLabel(): string {
      if (this.selectedToasCount === 0) return ''

      return `（${this.selectedToasCount}件）`
    },
    isInitialOwnerBlank(): boolean {
      return this.business.businessOwnerCompanyName === '' ||
             this.business.businessOwnerCompanyAddress === '' ||
             this.business.businessOwnerCompanyRepresentativeName === '' ||
             (this.business.transferSubject === '' && this.notStockBusiness)
    },
    isOwnerBlank(): boolean {
      return this.ownerCompanyName === '' ||
             this.ownerCompanyAddress === '' ||
             this.ownerCompanyRepresentativeName === '' ||
             (this.transferSubject === '' && this.notStockBusiness)
    },
    notStockBusiness(): boolean {
      return this.business.transferMethod !== 'stock'
    }
   },
   methods: {
    showModal(): void {
      this.modalShown = true
    },
    submit(): void {
      const formData = new FormData()
      this.submitting = true
      formData.append('bulk_deals[business_id]', this.business.id)
      this.toaIds.forEach((toaId) => {
        formData.append('bulk_deals[terms_of_acquisition_ids][]', toaId)
      })
      formData.append('bulk_deals[message_body]', this.messageBody)
      formData.append('bulk_deals[message_file]', this.messageFile)
      formData.append('bulk_deals[business_owner_company_name]', this.ownerCompanyName)
      formData.append('bulk_deals[business_owner_company_address]', this.ownerCompanyAddress)
      formData.append('bulk_deals[business_owner_company_representative_name]', this.ownerCompanyRepresentativeName)
      formData.append('bulk_deals[transfer_subject]', this.transferSubject)
      formData.append('save_source', '1')
      const callback = (): void => {
        showSuccess('一括紹介しました')
        this.submitted = true
      }
      const errorCallback = (message: string): void => {
        showError(message)
        this.submitting = false
      }
      this.$emit('onMessageSubmitted', { formData, callback, errorCallback })
    },
    onClickShowOtherBusiness(): void {
      Turbo.visit(sellersDashboardPath())
    },
  },
})

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-btn",
        {
          staticClass: "m-1",
          attrs: { variant: "primary", disabled: _vm.disabled },
          on: { click: _vm.showModal },
        },
        [
          _c("i", { staticClass: "fal fa-envelop" }),
          _vm._v(
            "\n    選択した買収ニーズに紹介する" +
              _vm._s(_vm.selectedToasCountLabel) +
              "\n  "
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: { size: "lg", "hide-footer": "", title: "案件一括紹介" },
          model: {
            value: _vm.modalShown,
            callback: function ($$v) {
              _vm.modalShown = $$v
            },
            expression: "modalShown",
          },
        },
        [
          _vm.submitted
            ? [
                _c("BulkDealSubmittedMessage", {
                  attrs: {
                    "next-business": _vm.nextBusiness,
                    "error-deals": _vm.errorDeals,
                  },
                }),
              ]
            : [
                _c("p", [
                  _vm._v("選択した買収ニーズ全てに一括で紹介を送ります。"),
                ]),
                _vm._v(" "),
                _c(
                  "label",
                  {
                    staticClass: "font-weight-bold",
                    attrs: { for: "business-toas-form-textarea" },
                  },
                  [_vm._v("紹介メッセージ")]
                ),
                _vm._v(" "),
                _c("textarea", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.messageBody,
                      expression: "messageBody",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: { id: "business-toas-form-textarea", rows: "10" },
                  domProps: { value: _vm.messageBody },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.messageBody = $event.target.value
                    },
                  },
                }),
                _vm._v(" "),
                _c("label", { staticClass: "font-weight-bold" }, [
                  _vm._v("参考資料"),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c("b-form-file", {
                      staticClass: "mt-1",
                      attrs: { placeholder: "ファイルを選択してください" },
                      model: {
                        value: _vm.messageFile,
                        callback: function ($$v) {
                          _vm.messageFile = $$v
                        },
                        expression: "messageFile",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.isInitialOwnerBlank
                  ? _c("div", [
                      _c("hr", { staticClass: "mt-3" }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "text-danger font-weight-bold" },
                        [
                          _vm._v(
                            "\n          紹介には所有企業情報を登録する必要があります。買い手には表示されません。\n        "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group mt-3" }, [
                        _c(
                          "label",
                          {
                            staticClass: "font-weight-bold",
                            attrs: { for: "owner-company-name" },
                          },
                          [_vm._v("事業会社名又は屋号")]
                        ),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.ownerCompanyName,
                              expression: "ownerCompanyName",
                            },
                          ],
                          staticClass: "form-control",
                          attrs: {
                            id: "owner-company-name",
                            required: "",
                            placeholder: "売却対象の事業会社名または屋号",
                          },
                          domProps: { value: _vm.ownerCompanyName },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.ownerCompanyName = $event.target.value
                            },
                          },
                        }),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group mt-3" }, [
                        _c(
                          "label",
                          {
                            staticClass: "font-weight-bold",
                            attrs: { for: "owner-company-address" },
                          },
                          [_vm._v("事業所所在地")]
                        ),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.ownerCompanyAddress,
                              expression: "ownerCompanyAddress",
                            },
                          ],
                          staticClass: "form-control",
                          attrs: {
                            id: "owner-company-address",
                            required: "",
                            placeholder: "売却対象会社名の所在地",
                          },
                          domProps: { value: _vm.ownerCompanyAddress },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.ownerCompanyAddress = $event.target.value
                            },
                          },
                        }),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group mt-3" }, [
                        _c(
                          "label",
                          {
                            staticClass: "font-weight-bold",
                            attrs: { for: "owner-company-representative-name" },
                          },
                          [_vm._v("代表者名")]
                        ),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.ownerCompanyRepresentativeName,
                              expression: "ownerCompanyRepresentativeName",
                            },
                          ],
                          staticClass: "form-control",
                          attrs: {
                            id: "owner-company-representative-name",
                            required: "",
                            placeholder: "売却対象会社の代表者名",
                          },
                          domProps: {
                            value: _vm.ownerCompanyRepresentativeName,
                          },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.ownerCompanyRepresentativeName =
                                $event.target.value
                            },
                          },
                        }),
                      ]),
                      _vm._v(" "),
                      _vm.notStockBusiness
                        ? _c("div", { staticClass: "form-group mt-3" }, [
                            _c(
                              "label",
                              {
                                staticClass: "font-weight-bold",
                                attrs: { for: "transfer-subject" },
                              },
                              [_vm._v("譲渡対象")]
                            ),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.transferSubject,
                                  expression: "transferSubject",
                                },
                              ],
                              staticClass: "form-control",
                              attrs: {
                                id: "transfer-subject",
                                required: "",
                                placeholder:
                                  "サービス名、店舗名、事業部など売却対象を記載",
                              },
                              domProps: { value: _vm.transferSubject },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.transferSubject = $event.target.value
                                },
                              },
                            }),
                          ])
                        : _vm._e(),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "row my-3" }, [
                  _c("div", { staticClass: "col-sm-8 mx-auto" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary w-100",
                        attrs: {
                          disabled:
                            _vm.isOwnerBlank ||
                            _vm.submitting ||
                            _vm.messageBody === "",
                          block: "",
                        },
                        on: { click: _vm.submit },
                      },
                      [_vm._v("\n            一括紹介する\n          ")]
                    ),
                  ]),
                ]),
              ],
        ],
        2
      ),
    ],
    1
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "app/javascript/src/components/BusinessToaMessageFormModalButton.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__